import React, { Fragment, ReactNode } from 'react'

interface IXLTProps {
  children?: ReactNode
}

export const MultiLineText = (props: IXLTProps) => {
  if (typeof props.children !== 'string') {
    return <></>
  }

  return (
    <>
      {props.children.split('\n').map((text, index) => {
        if (!text) {
          return <></>
        }

        return (
          <Fragment key={`multiLineText-${index}`}>
            {text}
            <br />
          </Fragment>
        )
      })}
    </>
  )
}
